import { render, staticRenderFns } from "./info.vue?vue&type=template&id=0b8c5e0e&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=0b8c5e0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c5e0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8c5e0e')) {
      api.createRecord('0b8c5e0e', component.options)
    } else {
      api.reload('0b8c5e0e', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=0b8c5e0e&scoped=true", function () {
      api.rerender('0b8c5e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/bet-zone/info.vue"
export default component.exports